import { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/DocumentTableColumns'

export const MAX_RECENT_DOCUMENTS = 20

const STORAGE_KEY_PREFIX = 'gecko_recent_documents'

function getStorageKey(userId: string, siteId: string): string {
  return `${STORAGE_KEY_PREFIX}_${userId}_${siteId}`
}

export function getRecentDocuments(
  userId: string,
  siteId: string
): DocumentTableRow[] {
  try {
    const key = getStorageKey(userId, siteId)
    const stored = localStorage.getItem(key)
    if (!stored) return []
    const documents = JSON.parse(stored) as DocumentTableRow[]
    return Array.isArray(documents) ? documents : []
  } catch (error) {
    console.warn('Failed to read recent documents from localStorage:', error)
    return []
  }
}

export function addRecentDocument(
  document: DocumentTableRow,
  userId: string,
  siteId: string
): DocumentTableRow[] {
  try {
    const documents = getRecentDocuments(userId, siteId)

    // If document is already in the list, move it to the front
    const filtered = documents.filter((d) => d.id !== document.id)

    const updatedDocuments = [document, ...filtered].slice(
      0,
      MAX_RECENT_DOCUMENTS
    )

    const key = getStorageKey(userId, siteId)
    localStorage.setItem(key, JSON.stringify(updatedDocuments))

    return updatedDocuments
  } catch (error) {
    if (error instanceof Error && error.name === 'QuotaExceededError') {
      console.warn('localStorage quota exceeded, clearing old documents')
      clearRecentDocuments(userId, siteId)
    } else {
      console.warn('Failed to save recent document to localStorage:', error)
    }
    return getRecentDocuments(userId, siteId)
  }
}

export function clearRecentDocuments(userId: string, siteId: string): void {
  try {
    const key = getStorageKey(userId, siteId)
    localStorage.removeItem(key)
  } catch (error) {
    console.warn('Failed to clear recent documents:', error)
  }
}
